import React from "react";
import { Route } from "react-router-dom";
import VendorStoreProfile from "../pages/vendor/StoreProfile";
import VendorLocations from "../pages/vendor/Locations";
import VendorPayoutsNew from "../pages/vendor/Payouts";
import VendorShipping from "../pages/vendor/Shipping";
import VendorSecurity from "../pages/vendor/Security";
import VendorOperational from "../pages/vendor/Operational";
import VendorAdvertising from "../pages/vendor/Advertising";
import VendorBilling from "../pages/vendor/Billing";
import VendorNotifications from "../pages/vendor/Notifications";
import VendorMessages from "../pages/vendor/Messages";
import CustomerRequests from "../pages/vendor/CustomerRequests";
import SubscriptionHub from "../pages/vendor/SubscriptionHub";
import TrainingAcademy from "../pages/vendor/TrainingAcademy";
import BrandRegistry from "../pages/vendor/BrandRegistry";
import AdWalletPage from "../pages/vendor/AdWalletPage";
import TaxInfoPage from "../pages/vendor/TaxInfoPage";
import TaxInvoices from "../pages/vendor/TaxInvoices";
import InvoiceViewer from "../pages/vendor/InvoiceViewer";
import VendorComplianceStatus from "../pages/VendorComplianceStatus";
import VendorTaxRegistration from "../pages/VendorTaxRegistration";
import VendorTaxDashboard from "../pages/VendorTaxDashboard";
import VendorShippingSettings from "../pages/VendorShippingSettings";
import SubscriberManagement from "../pages/vendor/SubscriberManagement";
import CreateCampaign from "../pages/CreateCampaign";
import FeedbackPage from "../pages/FeedbackPage";
import VendorWalletLedger from "../pages/vendor/VendorWalletLedger";
import VendorCommissionInvoices from "../pages/vendor/CommissionInvoices";

/**
 * Vendor-specific settings and profile routes.
 */
export const VendorRoutes = ({ PrivateRoute }) => (
  <>
    <Route path="/vendor/store-profile" element={<PrivateRoute><VendorStoreProfile /></PrivateRoute>} />
    <Route path="/vendor/locations" element={<PrivateRoute><VendorLocations /></PrivateRoute>} />
    <Route path="/vendor/payouts" element={<PrivateRoute><VendorPayoutsNew /></PrivateRoute>} />
    <Route path="/vendor/ad-wallet" element={<PrivateRoute><AdWalletPage /></PrivateRoute>} />
    <Route path="/vendor/wallet" element={<PrivateRoute><VendorWalletLedger /></PrivateRoute>} />
    <Route path="/vendor/commission-invoices" element={<PrivateRoute><VendorCommissionInvoices /></PrivateRoute>} />
    <Route path="/vendor/tax-info" element={<PrivateRoute><TaxInfoPage /></PrivateRoute>} />
    <Route path="/vendor/tax-invoices" element={<PrivateRoute><TaxInvoices /></PrivateRoute>} />
    <Route path="/orders/:orderId/invoice" element={<PrivateRoute><InvoiceViewer /></PrivateRoute>} />
    <Route path="/vendor/brand-registry" element={<PrivateRoute><BrandRegistry /></PrivateRoute>} />
    <Route path="/vendor/shipping" element={<PrivateRoute><VendorShipping /></PrivateRoute>} />
    <Route path="/vendor/security" element={<PrivateRoute><VendorSecurity /></PrivateRoute>} />
    <Route path="/vendor/requests" element={<PrivateRoute><CustomerRequests /></PrivateRoute>} />
    <Route path="/vendor/operational" element={<PrivateRoute><VendorOperational /></PrivateRoute>} />
    <Route path="/vendor/advertising" element={<PrivateRoute><VendorAdvertising /></PrivateRoute>} />
    <Route path="/vendor/advertising/create" element={<PrivateRoute><CreateCampaign /></PrivateRoute>} />
    <Route path="/vendor/billing" element={<PrivateRoute><VendorBilling /></PrivateRoute>} />
    <Route path="/vendor/messages" element={<PrivateRoute><VendorMessages /></PrivateRoute>} />
    <Route path="/vendor/notifications" element={<PrivateRoute><VendorNotifications /></PrivateRoute>} />
    <Route path="/vendor/subscription-plans" element={<PrivateRoute><SubscriptionHub /></PrivateRoute>} />
    {/* iter-231B.3 — Alias route. TrialGate, OAuthSuccess, and the
        onboarding-allowed-paths list have always redirected to
        `/vendor/subscription-hub`, but only `/vendor/subscription-plans`
        was registered → trial-expired vendors hit the catch-all
        `<Route path="*" element={<Navigate to="/login" />}>` →
        AuthContext re-auth'd them → bounce back to /dashboard →
        TrialGate redirect → /vendor/subscription-hub 404 → /login →
        infinite loop (Chrome "Throttling navigation" warning). The
        loop only became user-visible after iter-231B made TrialGate
        return `null` while loading (previously it returned `children`
        which masked the failure with a brief working-dashboard flash). */}
    <Route path="/vendor/subscription-hub" element={<PrivateRoute><SubscriptionHub /></PrivateRoute>} />
    <Route path="/vendor/subscribers" element={<PrivateRoute><SubscriberManagement /></PrivateRoute>} />
    <Route path="/vendor/training" element={<PrivateRoute><TrainingAcademy /></PrivateRoute>} />
    <Route path="/vendor/compliance" element={<PrivateRoute><VendorComplianceStatus /></PrivateRoute>} />
    <Route path="/vendor/tax-registration" element={<PrivateRoute><VendorTaxRegistration /></PrivateRoute>} />
    <Route path="/vendor/tax-dashboard" element={<PrivateRoute><VendorTaxDashboard /></PrivateRoute>} />
    <Route path="/settings/shipping" element={<PrivateRoute><VendorShipping /></PrivateRoute>} />
    <Route path="/feedback" element={<PrivateRoute><FeedbackPage /></PrivateRoute>} />
  </>
);
